/* Notorious Hospitality: new customer offer on the order form (added 24 Oct 2026, changed 31 Oct 2026).
   Offer (from 31 Oct 2026): a venue's first order gets one free 300 g bag of dried citrus (lime, lemon, orange or
   grapefruit, the venue's choice) once the order reaches the minimum for its delivery zone, excluding MVA:
   Oslo 2,000 kr, Akershus 4,000 kr, rest of Norway 3,500 kr. The minimum applies to pickup too.
   (Before 31 Oct 2026 the offer needed 3 x Lemon and 3 x Lime Super Juice.)
   The page data comes from #nh-offer-data (snippet nh-welcome-offer), only for venues with no orders yet; the venue's
   postcode comes from #nh-horeca-data, the same data nh-horeca.js uses for the delivery zones.
   This script adds a box to the order summary (#nh-drawer) with the progress and the choice of bag, and saves the choice
   on the cart twice: as the attribute "Nykundetilbud" (shows on card checkout orders) and as a line in the order note
   (the note is sent with "Send bestilling", so it shows on invoiced orders too). When the order no longer qualifies,
   both are removed. It works next to nh-horeca.js and does not change it: it watches the order count it renders. */
(function () {
  'use strict';
  var dataEl = document.getElementById('nh-offer-data');
  var drawer = document.getElementById('nh-drawer');
  if (!dataEl || !drawer) return;
  var O;
  try { O = JSON.parse(dataEl.textContent); } catch (e) { return; }
  if (!O || !O.eligible) return;
  var T = O.t || {};
  var ATTR = 'Nykundetilbud';
  var NOTE_PREFIX = 'Nykundetilbud:';
  var ROOT = ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/').replace(/\/$/, '');
  var bags = O.bags || [];
  var cart = null;
  var busy = false;

  // Minimum order excluding MVA, in cents, by delivery zone (same postcode ranges as nh-horeca.js).
  var MIN = { oslo: 200000, akershus: 400000, posten: 350000 };
  var H = {};
  var hEl = document.getElementById('nh-horeca-data');
  if (hEl) { try { H = JSON.parse(hEl.textContent) || {}; } catch (e) { H = {}; } }
  var NB = H.lang === 'nb';
  function zoneKey(zip) {
    var digits = String(zip || '').replace(/\D/g, '');
    if (!digits) return 'oslo';
    var z = parseInt(digits, 10);
    if (z >= 1 && z <= 1299) return 'oslo';
    if ((z >= 1300 && z <= 1499) || (z >= 1540 && z <= 1559) || (z >= 1900 && z <= 2099) ||
        (z >= 2150 && z <= 2170) || (z >= 3430 && z <= 3499)) return 'akershus';
    return 'posten';
  }
  var minEx = MIN[zoneKey(H.zip)];
  var num0 = new Intl.NumberFormat(NB ? 'nb-NO' : 'en-GB', { maximumFractionDigits: 0 });
  function krWhole(cents) { return num0.format(Math.round(cents) / 100) + ' kr'; }

  function tr(key, vars) {
    var s = T[key] != null ? String(T[key]) : key;
    if (vars) Object.keys(vars).forEach(function (k) { s = s.split('{' + k + '}').join(vars[k]); });
    return s;
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (ch) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch];
    });
  }
  function api(url, body) {
    return fetch(ROOT + url, {
      method: body ? 'POST' : 'GET',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: body ? JSON.stringify(body) : undefined
    }).then(function (r) { if (!r.ok) throw new Error('cart'); return r.json(); });
  }

  // The box sits under the delivery box in the order summary.
  var box = document.createElement('div');
  box.className = 'box nho-offer';
  box.setAttribute('data-offer', '');
  var anchor = drawer.querySelector('[data-zone-box]');
  if (anchor && anchor.parentNode) anchor.parentNode.insertBefore(box, anchor.nextSibling);
  else drawer.insertBefore(box, drawer.firstChild);

  // Order total excluding MVA (store prices include 15% MVA).
  function netTotal() { return cart ? Math.round(cart.total_price / 1.15) : 0; }
  function chosenKey() {
    var v = cart && cart.attributes && cart.attributes[ATTR];
    if (!v) return '';
    for (var i = 0; i < bags.length; i++) if (v.indexOf(bags[i].product) > -1) return bags[i].key;
    return '';
  }
  function bagByKey(k) { for (var i = 0; i < bags.length; i++) if (bags[i].key === k) return bags[i]; return null; }
  function offerLine(bag) { return NOTE_PREFIX + ' gratis 1 x ' + bag.product + ' 300 g'; }
  // The order note without our line, then with the new line at the end (if any).
  function noteWith(line) {
    var rest = String((cart && cart.note) || '').split('\n').filter(function (l) { return l.indexOf(NOTE_PREFIX) !== 0; }).join('\n').replace(/\s+$/, '');
    return line ? (rest ? rest + '\n' + line : line) : rest;
  }

  function save(bag) {
    if (busy) return;
    busy = true;
    var attrs = {};
    attrs[ATTR] = bag ? offerLine(bag).replace(NOTE_PREFIX + ' ', '') : '';
    api('/cart/update.js', { attributes: attrs, note: noteWith(bag ? offerLine(bag) : '') })
      .then(function (c) {
        cart = c;
        var noteEl = drawer.querySelector('[data-note]');
        if (noteEl && document.activeElement !== noteEl) noteEl.value = c.note || '';
      })
      .catch(function () {})
      .then(function () { busy = false; paint(); });
  }

  function paint() {
    if (!cart) return;
    var ex = netTotal();
    var met = cart.item_count > 0 && ex >= minEx;
    var key = chosenKey();
    var html = '<p class="nho-offer__title">' + esc(tr('title')) + '</p>';
    if (!met) {
      html += '<p class="nho-offer__text">' + esc(tr('need', { min: krWhole(minEx) })) + '</p>' +
        '<p class="nho-offer__have">' + esc(tr('have', { now: krWhole(Math.min(ex, minEx)), min: krWhole(minEx) })) + '</p>' +
        '<div class="nh-progress" aria-hidden="true"><i style="width:' + Math.min(100, Math.round(ex / minEx * 100)) + '%"></i></div>';
    } else {
      html += '<fieldset class="nho-offer__pick"><legend class="nho-offer__text">' + esc(tr('pick')) + '</legend>' +
        bags.map(function (b) {
          return '<label><input type="radio" name="nho-offer-bag" value="' + esc(b.key) + '"' + (b.key === key ? ' checked' : '') + '> ' + esc(b.name) + '</label>';
        }).join('') + '</fieldset>';
      var cb = bagByKey(key);
      if (cb) html += '<p class="nho-offer__done">' + esc(tr('done', { name: cb.name })) + '</p>';
    }
    box.innerHTML = html;
    // Keep the cart in step: pick lime by default once the order qualifies, clear it when it no longer does.
    if (met && !key && bags.length && !busy) save(bags[0]);
    if (!met && key && !busy) save(null);
    // The venue may have edited our line out of the note: put it back.
    if (met && key && String(cart.note || '').indexOf(NOTE_PREFIX) < 0 && !busy) save(bagByKey(key));
  }

  box.addEventListener('change', function (e) {
    var r = e.target;
    if (!r || r.name !== 'nho-offer-bag') return;
    var b = bagByKey(r.value);
    if (b) save(b);
  });

  function load() { return api('/cart.js').then(function (c) { cart = c; paint(); }).catch(function () {}); }

  // nh-horeca.js updates the unit count after every cart change; reload the cart when it changes.
  var countEl = drawer.querySelector('[data-cart-count]');
  var timer = null;
  if (countEl && window.MutationObserver) {
    new MutationObserver(function () { clearTimeout(timer); timer = setTimeout(load, 300); })
      .observe(countEl, { childList: true, characterData: true, subtree: true });
  }
  // Line changes in the summary can keep the same unit count but change the total.
  var linesEl = drawer.querySelector('[data-lines]');
  if (linesEl && window.MutationObserver) {
    new MutationObserver(function () { clearTimeout(timer); timer = setTimeout(load, 300); })
      .observe(linesEl, { childList: true });
  }
  document.addEventListener('change', function (e) {
    if (e.target && e.target.matches && e.target.matches('[data-qty]')) { clearTimeout(timer); timer = setTimeout(load, 900); }
  });
  document.addEventListener('click', function (e) {
    if (e.target && e.target.closest && e.target.closest('[data-inc],[data-dec],[data-line-key]')) { clearTimeout(timer); timer = setTimeout(load, 900); }
  });
  load();
})();
